import React from "react";
import "./PainterServiceSections.css";

const PainterWhyChooseUs = ({ data }) => {
  return (
    <section className="pnt-why">
      <div className="pnt-container pnt-why-grid">
        <div className="pnt-why-left">
          <span className="pnt-tag">Why Choose Us</span>
          <h2 className="pnt-heading">{data.title}</h2>
          <p className="pnt-subheading pnt-subheading-left">{data.titleDesc}</p>
          <div className="pnt-why-badge">
            <span className="pnt-why-badge-value">100%</span>
            <span className="pnt-why-badge-label">
              Workmanship Warranty on every painting project we deliver
            </span>
          </div>
        </div>

        <div className="pnt-why-right">
          {data.main.map((reason, index) => (
            <div className="pnt-why-row pnt-fade" key={index}>
              <div className="pnt-why-icon">
                <img src={reason.icon} alt={reason.title} />
              </div>
              <div className="pnt-why-copy">
                <h3>{reason.title}</h3>
                <p>{reason.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PainterWhyChooseUs;
